var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilterRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_491_71)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 1054,
    transform: "translate(-166 -161)",
    fill: "#E8ECEF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_491_71)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -150,
    y: -49,
    width: 358,
    height: 78,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -102,
    y: -7,
    width: 118,
    height: 24,
    rx: 4,
    fill: "#E8ECEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9994 8L2 2M2.00064 8L8 2",
    stroke: "#007AFF",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_491_71",
    x: -162,
    y: -57,
    width: 382,
    height: 102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_491_71"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_491_71",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_491_71"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 1054,
    fill: "white",
    transform: "translate(-166 -161)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterRemove);
export default __webpack_public_path__ + "static/media/Icon_Filter_Remove.6f4b8a281805c9337ab62535bf5a8ff5.svg";
export { ForwardRef as ReactComponent };